import { Popover } from "bootstrap"

export const popover = {
  mounted( el ) {
    let opts = {
      trigger: 'hover',
      container: 'body',
    }

    if ( el.hasAttribute( 'data-bs-content-id' ) ) {
      opts.content = document.getElementById( el.getAttribute( 'data-bs-content-id' ) ).innerHTML
      opts.html = true
    }

    const tooltip = Popover.getOrCreateInstance( el, opts )

    el.addEventListener( 'shown.bs.popover', () => {
      setTimeout(() => {
        tooltip.hide();
      },
     10000); // 10 seconds
    } )

    el.addEventListener( 'click', () => {
       tooltip.hide();
    })
  }
}